import { render, staticRenderFns } from "./DatepickerCalendar.vue?vue&type=template&id=1128c81d&"
import script from "./DatepickerCalendar.vue?vue&type=script&lang=js&"
export * from "./DatepickerCalendar.vue?vue&type=script&lang=js&"
import style0 from "./DatepickerCalendar.vue?vue&type=style&index=0&id=1128c81d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports